/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const n=Symbol("ImageElementInstance"),e=Symbol("VideoElementInstance");function t(e){return null!=e&&"object"==typeof e&&n in e}function o(n){return null!=n&&"object"==typeof n&&e in n}function c(n){return t(n)||o(n)}export{n as ImageElementSymbol,e as VideoElementSymbol,t as isImageElement,c as isMediaElement,o as isVideoElement};
